export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      limit: 'Límite',
      contracts: 'Contratos',
      bitacora: 'Bitácora',
      estudio: 'Estudio',
      plan: 'Mi Plan',
      practice: 'Práctica',
      admin: 'Admin',
      logout: 'Salir',
      settings: 'Ajustes',
    },
    auth: {
      title: 'METODO 11',
      login: 'Inicia sesión en tu cuenta',
      register: 'Crea una nueva cuenta',
      forgotCode: 'Recuperar código de acceso',
      resetPassword: 'Restablecer contraseña',
      username: 'Usuario',
      usernamePlaceholder: 'Tu nombre de usuario',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      recoveryCode: 'Código de Recuperación',
      recoveryCodePlaceholder: 'CÓDIGO',
      password: 'Contraseña',
      newPassword: 'Nueva Contraseña',
      passwordPlaceholder: '••••••••',
      loginBtn: 'ENTRAR',
      registerBtn: 'REGISTRARSE',
      sendCodeBtn: 'ENVIAR CÓDIGO',
      resetBtn: 'RESTABLECER',
      noAccount: '¿No tienes cuenta? Regístrate',
      forgotPassword: '¿Olvidaste tu contraseña?',
      forgotRecoveryCode: '¿Olvidaste tu código de recuperación?',
      backToLogin: 'Volver al inicio de sesión',
      accountCreated: '¡Cuenta Creada!',
      saveRecoveryCode: 'Guarda este código de recuperación en un lugar seguro. Lo necesitarás si olvidas tu contraseña.',
      continueToApp: 'Continuar a la App',
      loading: 'Cargando...',
      errorLogin: 'Error al iniciar sesión',
      errorRegister: 'Error al registrarse',
      errorReset: 'Error al restablecer contraseña',
      errorRecover: 'Error al recuperar código',
      errorConnection: 'Error de conexión',
      resetSuccess: 'Contraseña restablecida. Nuevo código: ',
      rememberMe: 'Recordar usuario',
      googleLogin: 'Continuar con Google',
      or: 'o',
    },
    home: {
      welcomeAdmin: 'Bienvenido, Administrador',
      welcomeUser: 'Gestión centralizada de tus operaciones de trading',
      newEntry: 'NUEVA ENTRADA',
      newEntryDesc: 'Registra una nueva operación en tu bitácora',
      calculators: 'Calculadoras',
      limitTitle: 'Calculadora de Límite',
      limitDesc: 'Calcula el 10% y el costo total con broker fee',
      contractsTitle: 'Calculadora de Contratos',
      contractsDesc: 'Calcula cuántos contratos puedes comprar',
      practiceTitle: 'Práctica',
      practiceDesc: 'Calendario de disciplina y protocolo de cuenta real',
      adminTitle: 'Panel de Control',
      adminDesc: 'Gestionar usuarios, roles y accesos',
      bitacoraTitle: 'Bitácora',
      bitacoraDesc: 'Historial completo de todas tus operaciones',
      estudioTitle: 'Estudio',
      estudioDesc: 'Análisis profundo de trades negativos',
      planTitle: 'Mi Plan',
      planDesc: 'Planificación y seguimiento de objetivos',
      databases: 'Bases de Datos',
      adminAndData: 'Administración y Datos',
    },
    calc: {
      limitTitle: 'Calculadora de Límite',
      contractsTitle: 'Calculadora de Contratos',
      currentPrice: 'Precio Actual',
      brokerFee: 'Broker Fee',
      targetPercent: '% Objetivo',
      targetValue: ' del Valor',
      totalValue: 'Valor Total',
      contractValue: 'Valor del Contrato',
      totalBudget: 'Presupuesto Total',
      quantity: 'Cantidad de Contratos',
      popoutTitle: 'Calculadora en ventana flotante',
      popoutDesc: 'Esta herramienta está abierta en otra ventana.',
      bringBack: 'Traer de vuelta',
      popoutError: 'No se pudo abrir la ventana flotante.',
    },
    bitacora: {
      title: 'BITÁCORA',
      estudioTitle: 'ESTUDIO (Trades Negativos)',
      noEntries: 'No hay entradas registradas aún.',
      date: 'Fecha',
      time: 'Hora',
      symbol: 'Símbolo',
      strike: 'Strike',
      expDate: 'Expira',
      type: 'Tipo',
      qty: 'Cant',
      buyPrice: 'P. Compra',
      totalInvested: 'Inv. Total',
      limitPrice: 'P. Límite',
      sellDate: 'F. Venta',
      sellTime: 'H. Venta',
      sellPrice: 'P. Venta',
      totalSale: 'Venta Total',
      profit: 'Profit',
      profitPercent: '% Profit',
      td: 'TD',
      notes: 'Notas',
      actions: 'Acciones',
      deleteConfirm: '¿Estás seguro de eliminar esta entrada?',
    },
    form: {
      newEntry: 'Nueva Entrada de Trade',
      editEntry: 'Editar Entrada',
      updateEntry: 'Actualizar Entrada',
      saveTrade: 'Guardar Trade',
      date: 'Fecha y Hora',
      setup: 'Setup / Estrategia',
      contracts: 'Contratos',
      entryPrice: 'Precio de Entrada',
      exitPrice: 'Precio de Salida',
      profit: 'Profit / Loss ($)',
      notes: 'Notas / Observaciones',
      save: 'Guardar Entrada',
      updating: 'Actualizando...',
      saving: 'Guardando...',
      selectNegativeReason: 'Seleccionar razón del trade negativo',
      emotionallyUnstable: 'Emocionalmente Desenfocado',
      incorrectLines: 'Trazado de Líneas Incorrecto',
      unstableBands: 'Bandas Inestables',
      unstableCandles: 'Velas Inestables',
      earlyEntry: 'Entrada Anticipada',
      lateEntry: 'Entrada Tardía',
      movedLimit: 'Moví el Límite (SL)',
      overtraded: 'Sobreopere (Overtrading)',
    },
    plan: {
      title: 'PLAN DE TRADING',
      initialInvestment: 'Inversión Inicial',
      limitPerTrade: 'Límite por Trade',
      currentBalance: 'Balance Actual',
      totalProfit: 'Profit Total',
      tradesCount: 'Total Trades',
      winRate: 'Win Rate',
      reset: 'Reiniciar Plan',
      resetPlan: 'Reiniciar Plan',
      undo: 'Deshacer Reinicio',
      undoDelete: 'Deshacer Reinicio',
      resetConfirm: '¿Deseas reiniciar los valores del Plan y la Bitácora?',
      trades: 'Trades',
      trade: 'Trade',
      investment: 'Inversión',
      profit: 'Profit',
      profitPlus: 'Profit +',
      extraction: 'Extracción',
    },
    practice: {
      title: 'DISCIPLINA Y PRÁCTICA',
      calendar: 'Calendario de Disciplina',
      protocol: 'Protocolo de Cuenta Real',
      day: 'Día',
      status: 'Estado',
      completed: 'Completado',
      pending: 'Pendiente',
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
      daysShort: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
      continueSim: 'CONTINUAR EN SIMULADOR',
      missingData: 'Faltan datos',
      missingDataDesc: 'para evaluar',
      disciplineLow: 'Disciplina Insuficiente',
      disciplineLowDetail: 'Disciplina < 85%',
      monthlyCompletion: 'Completado Mensual',
      consecutiveErrorsDetail: 'Errores Consecutivos > 1',
      graveViolationDetail: 'Violación Grave de Reglas',
      approvedReal: 'APROBADO PARA REAL',
      approvedDesc: 'Cumples con todos los criterios para operar en real.',
      monthlyCompletionDetail: 'Completado Mensual > 90%',
      disciplineHighDetail: 'Disciplina >= 90%',
      maxOneErrorDetail: 'Máx 1 Error Consecutivo',
      noGraveViolationDetail: 'Sin Violaciones Graves',
      observation: 'EN OBSERVACIÓN',
      observationDesc: 'Buen desempeño, pero requiere revisión detallada.',
      disciplineMidDetail: 'Disciplina 85-89%',
      detailedReviewDetail: 'Revisión Detallada Requerida',
      disciplineCalendar: 'Calendario de Disciplina',
      resetMonth: 'Reiniciar Mes',
      resetYear: 'Reiniciar Año',
      resetMonthConfirm: '¿Deseas reiniciar todos los días de este mes?',
      resetYearConfirm: '¿Deseas reiniciar todos los días de este año?',
      protocolTitle: 'PROTOCOLO DE CUENTA REAL',
      objective: 'OBJETIVO',
      objectiveDesc: 'Demostrar consistencia y disciplina antes de arriesgar capital real.',
      mandatoryRegistration: 'REGISTRO OBLIGATORIO',
      markDayWith: 'Marcar cada día con',
      correctDecision: 'Decisión Correcta (Trade o No Trade)',
      ruleViolation: 'Violación de Reglas / Error',
      noBlankSpaces: '* No dejar espacios en blanco en días operativos',
      consideredOneWhen: 'SE CONSIDERA VERDE CUANDO',
      onlyTradedStrategy: 'Solo operé mi estrategia definida',
      noTradeNoSignal: 'No operé porque no hubo señal clara',
      respectedRiskPlan: 'Respeté mi plan de riesgo',
      executedNoImprov: 'Ejecuté sin dudar y sin improvisar',
      disciplineMatters: 'LA DISCIPLINA ES LO ÚNICO QUE IMPORTA',
      consideredZeroWhen: 'SE CONSIDERA ROJO CUANDO',
      forcedEntry: 'Forcé una entrada sin señal clara',
      noConfirmation: 'Entré antes de tiempo (sin confirmación)',
      brokeRiskManagement: 'Rompí mi gestión de riesgo',
      actedImpulse: 'Actué por impulso, miedo o avaricia',
      approvalCriteria: 'CRITERIOS DE APROBACIÓN',
      toOperateReal: 'PARA OPERAR EN REAL:',
      minDisciplineLastMonth: 'Mínimo 90% de disciplina en el mes de diciembre',
      noConsecutiveErrors: 'No más de 1 día de error consecutivo',
      clearUnderstanding: 'Entendimiento claro de cada error cometido',
      ifPercentLow: 'SI EL PORCENTAJE ES < 90%',
      noRealOperate: 'NO SE OPERA EN REAL',
      continuePractice: 'Se continúa en simulador hasta recuperar la métrica.',
      fundamentalPrinciple: 'PRINCIPIO FUNDAMENTAL',
      protectCapital: 'Tu trabajo principal es proteger tu capital.',
      noTradeIsCorrect: 'No operar también es una decisión correcta.',
      evaluationPanel: 'PANEL DE EVALUACIÓN',
      conditionsEvaluated: 'CONDICIONES EVALUADAS',
      completion: 'COMPLETADO',
      goal: 'META',
      discipline: 'DISCIPLINA',
      yearlyDiscipline: 'DISCIPLINA ANUAL',
      yearlyAverage: 'PROMEDIO ANUAL',
      totalTrades: 'TOTAL DÍAS',
      trades: 'DÍAS',
      positiveTrades: 'DÍAS POSITIVOS',
      negativeTrades: 'DÍAS NEGATIVOS',
      yearlyDayBalance: 'BALANCE DE DÍAS ANUAL',
      positiveShort: 'POS',
      negativeShort: 'NEG',
    },
    admin: {
      title: 'PANEL DE ADMINISTRACIÓN',
      addUser: 'Agregar Usuario',
      errorLoading: 'Error al cargar usuarios',
      connectionError: 'Error de conexión',
      user: 'Usuario',
      createdSuccess: 'creado exitosamente',
      code: 'Código',
      errorCreating: 'Error al crear usuario',
      updatedSuccess: 'actualizado exitosamente',
      errorUpdating: 'Error al actualizar usuario',
      deleteConfirm: '¿Estás seguro de eliminar este usuario?',
      deletedSuccess: 'Usuario eliminado exitosamente',
      errorDeleting: 'Error al eliminar usuario',
      userEmail: 'USUARIO / EMAIL',
      role: 'ROL',
      actions: 'ACCIONES',
      noEmail: 'Sin email',
      adminRole: 'ADMIN',
      userRole: 'USUARIO',
      edit: 'Editar',
      delete: 'Eliminar',
      editUser: 'Editar Usuario',
      newUser: 'Nuevo Usuario',
      usernameLabel: 'NOMBRE DE USUARIO',
      emailLabel: 'CORREO ELECTRÓNICO',
      passwordLabel: 'CONTRASEÑA',
      newPasswordLabel: 'NUEVA CONTRASEÑA (DEJAR EN BLANCO PARA MANTENER)',
      assignAdmin: 'Asignar permisos de Administrador',
      updateUser: 'Actualizar Usuario',
      createUser: 'Crear Usuario',
    },
    settings: {
      title: 'AJUSTES DE USUARIO',
      profile: 'Perfil',
      security: 'Seguridad',
      recoveryCode: 'Tu Código de Recuperación',
      recoveryCodeDesc: 'Este código es necesario para restablecer tu contraseña si la olvidas. Guárdalo en un lugar seguro.',
      email: 'Correo Electrónico',
      username: 'Nombre de Usuario',
      role: 'Rol de Usuario',
      admin: 'Administrador',
      user: 'Usuario Estándar',
      saveChanges: 'Guardar Cambios',
      changePassword: 'Cambiar Contraseña',
      deleteAccount: 'Eliminar Cuenta',
      deleteAccountDesc: 'Esta acción es permanente y borrará toda tu información (Bitácora, Plan, Práctica, etc.).',
      deleteAccountConfirm: '¿Estás seguro de que deseas eliminar tu cuenta permanentemente?',
    },
    common: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      save: 'Guardar',
      loading: 'Cargando...',
    }
  },
  en: {
    nav: {
      home: 'Home',
      limit: 'Limit',
      contracts: 'Contracts',
      bitacora: 'Logbook',
      estudio: 'Study',
      plan: 'My Plan',
      practice: 'Practice',
      admin: 'Admin',
      logout: 'Logout',
      settings: 'Settings',
    },
    auth: {
      title: 'METHOD 11',
      login: 'Log in to your account',
      register: 'Create a new account',
      forgotCode: 'Recover access code',
      resetPassword: 'Reset password',
      username: 'Username',
      usernamePlaceholder: 'Your username',
      email: 'Email',
      emailPlaceholder: 'you@email.com',
      recoveryCode: 'Recovery Code',
      recoveryCodePlaceholder: 'CODE',
      password: 'Password',
      newPassword: 'New Password',
      passwordPlaceholder: '••••••••',
      loginBtn: 'LOGIN',
      registerBtn: 'REGISTER',
      sendCodeBtn: 'SEND CODE',
      resetBtn: 'RESET',
      noAccount: "Don't have an account? Register",
      forgotPassword: 'Forgot your password?',
      forgotRecoveryCode: 'Forgot your recovery code?',
      backToLogin: 'Back to login',
      accountCreated: 'Account Created!',
      saveRecoveryCode: 'Save this recovery code in a safe place. You will need it if you forget your password.',
      continueToApp: 'Continue to App',
      loading: 'Loading...',
      errorLogin: 'Error logging in',
      errorRegister: 'Error registering',
      errorReset: 'Error resetting password',
      errorRecover: 'Error recovering code',
      errorConnection: 'Connection error',
      resetSuccess: 'Password reset. New code: ',
      rememberMe: 'Remember me',
      googleLogin: 'Continue with Google',
      or: 'or',
    },
    home: {
      welcomeAdmin: 'Welcome, Administrator',
      welcomeUser: 'Centralized management of your trading operations',
      newEntry: 'NEW ENTRY',
      newEntryDesc: 'Register a new operation in your logbook',
      calculators: 'Calculators',
      limitTitle: 'Limit Calculator',
      limitDesc: 'Calculate 10% and total cost with broker fee',
      contractsTitle: 'Contracts Calculator',
      contractsDesc: 'Calculate how many contracts you can buy',
      practiceTitle: 'Practice',
      practiceDesc: 'Discipline calendar and real account protocol',
      adminTitle: 'Control Panel',
      adminDesc: 'Manage users, roles and access',
      bitacoraTitle: 'Logbook',
      bitacoraDesc: 'Full history of all your operations',
      estudioTitle: 'Study',
      estudioDesc: 'In-depth analysis of negative trades',
      planTitle: 'My Plan',
      planDesc: 'Planning and goal tracking',
      databases: 'Databases',
      adminAndData: 'Admin and Data',
    },
    calc: {
      limitTitle: 'Limit Calculator',
      contractsTitle: 'Contracts Calculator',
      currentPrice: 'Current Price',
      brokerFee: 'Broker Fee',
      targetPercent: 'Target %',
      targetValue: ' of Value',
      totalValue: 'Total Value',
      contractValue: 'Contract Value',
      totalBudget: 'Total Budget',
      quantity: 'Quantity of Contracts',
      popoutTitle: 'Calculator in floating window',
      popoutDesc: 'This tool is open in another window.',
      bringBack: 'Bring back',
      popoutError: 'Could not open floating window.',
    },
    bitacora: {
      title: 'LOGBOOK',
      estudioTitle: 'STUDY (Negative Trades)',
      noEntries: 'No entries recorded yet.',
      date: 'Date',
      time: 'Time',
      symbol: 'Symbol',
      strike: 'Strike',
      expDate: 'Exp',
      type: 'Type',
      qty: 'Qty',
      buyPrice: 'Buy Price',
      totalInvested: 'Total Inv',
      limitPrice: 'Limit Price',
      sellDate: 'Sell Date',
      sellTime: 'Sell Time',
      sellPrice: 'Sell Price',
      totalSale: 'Total Sale',
      profit: 'Profit',
      profitPercent: '% Profit',
      td: 'TD',
      notes: 'Notes',
      actions: 'Actions',
      deleteConfirm: 'Are you sure you want to delete this entry?',
    },
    form: {
      newEntry: 'New Trade Entry',
      editEntry: 'Edit Entry',
      updateEntry: 'Update Entry',
      saveTrade: 'Save Trade',
      date: 'Date and Time',
      setup: 'Setup / Strategy',
      contracts: 'Contracts',
      entryPrice: 'Entry Price',
      exitPrice: 'Exit Price',
      profit: 'Profit / Loss ($)',
      notes: 'Notes / Observations',
      save: 'Save Entry',
      updating: 'Updating...',
      saving: 'Saving...',
      selectNegativeReason: 'Select reason for negative trade',
      emotionallyUnstable: 'Emotionally Unstable',
      incorrectLines: 'Incorrect Line Drawing',
      unstableBands: 'Unstable Bands',
      unstableCandles: 'Unstable Candles',
      earlyEntry: 'Early Entry',
      lateEntry: 'Late Entry',
      movedLimit: 'Moved Limit (SL)',
      overtraded: 'Overtraded',
    },
    plan: {
      title: 'TRADING PLAN',
      initialInvestment: 'Initial Investment',
      limitPerTrade: 'Limit per Trade',
      currentBalance: 'Current Balance',
      totalProfit: 'Total Profit',
      tradesCount: 'Total Trades',
      winRate: 'Win Rate',
      reset: 'Reset Plan',
      resetPlan: 'Reset Plan',
      undo: 'Undo Reset',
      undoDelete: 'Undo Reset',
      resetConfirm: 'Do you want to reset Plan and Logbook values?',
      trades: 'Trades',
      trade: 'Trade',
      investment: 'Investment',
      profit: 'Profit',
      profitPlus: 'Profit +',
      extraction: 'Extraction',
    },
    practice: {
      title: 'DISCIPLINE AND PRACTICE',
      calendar: 'Discipline Calendar',
      protocol: 'Real Account Protocol',
      day: 'Day',
      status: 'Status',
      completed: 'Completed',
      pending: 'Pending',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
      daysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      continueSim: 'CONTINUE IN SIMULATOR',
      missingData: 'Missing data',
      missingDataDesc: 'to evaluate',
      disciplineLow: 'Insufficient Discipline',
      disciplineLowDetail: 'Discipline < 85%',
      monthlyCompletion: 'Monthly Completion',
      consecutiveErrorsDetail: 'Consecutive Errors > 1',
      graveViolationDetail: 'Grave Rule Violation',
      approvedReal: 'APPROVED FOR REAL',
      approvedDesc: 'You meet all criteria to trade real money.',
      monthlyCompletionDetail: 'Monthly Completion > 90%',
      disciplineHighDetail: 'Discipline >= 90%',
      maxOneErrorDetail: 'Max 1 Consecutive Error',
      noGraveViolationDetail: 'No Grave Violations',
      observation: 'UNDER OBSERVATION',
      observationDesc: 'Good performance, but requires detailed review.',
      disciplineMidDetail: 'Discipline 85-89%',
      detailedReviewDetail: 'Detailed Review Required',
      disciplineCalendar: 'Discipline Calendar',
      resetMonth: 'Reset Month',
      resetYear: 'Reset Year',
      resetMonthConfirm: 'Do you want to reset all days for this month?',
      resetYearConfirm: 'Do you want to reset all days for this year?',
      protocolTitle: 'REAL ACCOUNT PROTOCOL',
      objective: 'OBJECTIVE',
      objectiveDesc: 'Demonstrate consistency and discipline before risking real capital.',
      mandatoryRegistration: 'MANDATORY REGISTRATION',
      markDayWith: 'Mark each day with',
      correctDecision: 'Correct Decision (Trade or No Trade)',
      ruleViolation: 'Rule Violation / Error',
      noBlankSpaces: '* Do not leave blank spaces on trading days',
      consideredOneWhen: 'CONSIDERED GREEN WHEN',
      onlyTradedStrategy: 'Only traded my defined strategy',
      noTradeNoSignal: 'Did not trade because there was no clear signal',
      respectedRiskPlan: 'Respected my risk plan',
      executedNoImprov: 'Executed without hesitation and without improvising',
      disciplineMatters: 'DISCIPLINE IS THE ONLY THING THAT MATTERS',
      consideredZeroWhen: 'CONSIDERED RED WHEN',
      forcedEntry: 'Forced an entry without clear signal',
      noConfirmation: 'Entered too early (no confirmation)',
      brokeRiskManagement: 'Broke my risk management',
      actedImpulse: 'Acted on impulse, fear or greed',
      approvalCriteria: 'APPROVAL CRITERIA',
      toOperateReal: 'TO TRADE REAL:',
      minDisciplineLastMonth: 'Minimum 90% discipline in the month of December',
      noConsecutiveErrors: 'No more than 1 consecutive error day',
      clearUnderstanding: 'Clear understanding of each error committed',
      ifPercentLow: 'IF PERCENTAGE IS < 90%',
      noRealOperate: 'DO NOT TRADE REAL',
      continuePractice: 'Continue in simulator until metric is recovered.',
      fundamentalPrinciple: 'FUNDAMENTAL PRINCIPLE',
      protectCapital: 'Your main job is to protect your capital.',
      noTradeIsCorrect: 'Not trading is also a correct decision.',
      evaluationPanel: 'EVALUATION PANEL',
      conditionsEvaluated: 'EVALUATED CONDITIONS',
      completion: 'COMPLETION',
      goal: 'GOAL',
      discipline: 'DISCIPLINE',
      yearlyDiscipline: 'YEARLY DISCIPLINE',
      yearlyAverage: 'YEARLY AVERAGE',
      totalTrades: 'TOTAL DAYS',
      trades: 'DAYS',
      positiveTrades: 'POSITIVE DAYS',
      negativeTrades: 'NEGATIVE DAYS',
      yearlyDayBalance: 'YEARLY DAY BALANCE',
      positiveShort: 'POS',
      negativeShort: 'NEG',
    },
    admin: {
      title: 'ADMIN PANEL',
      addUser: 'Add User',
      errorLoading: 'Error loading users',
      connectionError: 'Connection error',
      user: 'User',
      createdSuccess: 'created successfully',
      code: 'Code',
      errorCreating: 'Error creating user',
      updatedSuccess: 'updated successfully',
      errorUpdating: 'Error updating user',
      deleteConfirm: 'Are you sure you want to delete this user?',
      deletedSuccess: 'User deleted successfully',
      errorDeleting: 'Error deleting user',
      userEmail: 'USER / EMAIL',
      role: 'ROLE',
      actions: 'ACTIONS',
      noEmail: 'No email',
      adminRole: 'ADMIN',
      userRole: 'USER',
      edit: 'Edit',
      delete: 'Delete',
      editUser: 'Edit User',
      newUser: 'New User',
      usernameLabel: 'USERNAME',
      emailLabel: 'EMAIL',
      passwordLabel: 'PASSWORD',
      newPasswordLabel: 'NEW PASSWORD (LEAVE BLANK TO KEEP)',
      assignAdmin: 'Assign Admin permissions',
      updateUser: 'Update User',
      createUser: 'Create User',
    },
    settings: {
      title: 'USER SETTINGS',
      profile: 'Profile',
      security: 'Security',
      recoveryCode: 'Your Recovery Code',
      recoveryCodeDesc: 'This code is required to reset your password if you forget it. Keep it in a safe place.',
      email: 'Email Address',
      username: 'Username',
      role: 'User Role',
      admin: 'Administrator',
      user: 'Standard User',
      saveChanges: 'Save Changes',
      changePassword: 'Change Password',
      deleteAccount: 'Delete Account',
      deleteAccountDesc: 'This action is permanent and will delete all your information (Bitacora, Plan, Practice, etc.).',
      deleteAccountConfirm: 'Are you sure you want to delete your account permanently?',
    },
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      save: 'Save',
      loading: 'Loading...',
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      limit: 'Limite',
      contracts: 'Contrats',
      bitacora: 'Journal',
      estudio: 'Étude',
      plan: 'Mon Plan',
      practice: 'Pratique',
      admin: 'Admin',
      logout: 'Déconnexion',
      settings: 'Paramètres',
    },
    auth: {
      title: 'MÉTHODE 11',
      login: 'Connectez-vous à votre compte',
      register: 'Créer un nouveau compte',
      forgotCode: 'Récupérer le code d\'accès',
      resetPassword: 'Réinitialiser le mot de passe',
      username: 'Nom d\'utilisateur',
      usernamePlaceholder: 'Votre nom d\'utilisateur',
      email: 'Email',
      emailPlaceholder: 'vous@email.com',
      recoveryCode: 'Code de Récupération',
      recoveryCodePlaceholder: 'CODE',
      password: 'Mot de passe',
      newPassword: 'Nouveau Mot de Passe',
      passwordPlaceholder: '••••••••',
      loginBtn: 'SE CONNECTER',
      registerBtn: 'S\'INSCRIRE',
      sendCodeBtn: 'ENVOYER LE CODE',
      resetBtn: 'RÉINITIALISER',
      noAccount: 'Pas de compte? S\'inscrire',
      forgotPassword: 'Mot de passe oublié?',
      forgotRecoveryCode: 'Code de récupération oublié?',
      backToLogin: 'Retour à la connexion',
      accountCreated: 'Compte Créé!',
      saveRecoveryCode: 'Enregistrez ce code de récupération en lieu sûr. Vous en aurez besoin si vous oubliez votre mot de passe.',
      continueToApp: 'Continuer vers l\'App',
      loading: 'Chargement...',
      errorLogin: 'Erreur de connexion',
      errorRegister: 'Erreur d\'inscription',
      errorReset: 'Erreur de réinitialisation',
      errorRecover: 'Erreur de récupération du code',
      errorConnection: 'Erreur de connexion',
      resetSuccess: 'Mot de passe réinitialisé. Nouveau code: ',
      rememberMe: 'Se souvenir de moi',
      googleLogin: 'Continuer avec Google',
      or: 'ou',
    },
    home: {
      welcomeAdmin: 'Bienvenue, Administrateur',
      welcomeUser: 'Gestion centralisée de vos opérations de trading',
      newEntry: 'NOUVELLE ENTRÉE',
      newEntryDesc: 'Enregistrez une nouvelle opération dans votre journal',
      calculators: 'Calculatrices',
      limitTitle: 'Calculatrice de Limite',
      limitDesc: 'Calculez 10% et le coût total avec frais de courtage',
      contractsTitle: 'Calculatrice de Contrats',
      contractsDesc: 'Calculez combien de contrats vous pouvez acheter',
      practiceTitle: 'Pratique',
      practiceDesc: 'Calendrier de discipline et protocole de compte réel',
      databases: 'Bases de Données',
      adminAndData: 'Admin et Données',
      bitacoraTitle: 'Bitácora',
      bitacoraDesc: 'Historique complet de toutes vos opérations',
      estudioTitle: 'Étude',
      estudioDesc: 'Analyse approfondie des trades négatifs',
      planTitle: 'Mon Plan',
      planDesc: 'Planification et suivi des objectifs',
      adminTitle: 'Panneau Admin',
      adminDesc: 'Gestion des utilisateurs et accès',
    },
    calc: {
      limitTitle: 'Calculatrice de Limite',
      contractsTitle: 'Calculatrice de Contrats',
      currentPrice: 'Prix Actuel',
      brokerFee: 'Frais de Courtage',
      targetPercent: 'Pourcentage Cible',
      percentOfValue: 'du Prix',
      totalValue: 'Valeur Totale',
      contractValue: 'Valeur du Contrat',
      totalBudget: 'Budget Total',
      quantityContracts: 'Quantité de Contrats',
    },
    bitacora: {
      newEntry: 'Nouvelle Entrée',
      date: 'Date',
      time: 'Heure',
      symbol: 'Symbole',
      strike: 'Strike',
      expDate: 'Expiration',
      type: 'Type',
      qty: 'Qté',
      buyPrice: 'Prix Achat',
      totalInvested: 'Inv. Total',
      limitPrice: 'Prix Limite',
      sellDate: 'Date Vente',
      sellTime: 'Heure Vente',
      sellPrice: 'Prix Vente',
      totalSale: 'Vente Total',
      profit: 'Profit',
      profitPercent: '% Profit',
      td: 'TD',
      notes: 'Notes',
      noEntries: 'Aucune entrée encore. Ajoutez votre premier trade!',
      call: 'Call',
      put: 'Put',
    },
    plan: {
      title: 'Mon Plan de Trading',
      initialInvestment: 'Investissement Initial',
      description: 'Description',
      addGoal: 'Ajouter Objectif',
      noGoals: 'Aucun objectif défini',
      resetConfirm: 'Êtes-vous sûr de réinitialiser le plan?',
    },
    practice: {
      disciplineCalendar: 'Calendrier de Discipline',
      resetMonth: 'Réinitialiser Mois',
      resetYear: 'Réinitialiser Année',
      resetMonthConfirm: 'Réinitialiser tous les jours de ce mois?',
      resetYearConfirm: 'Réinitialiser toute l\'année?',
      january: 'Janvier', february: 'Février', march: 'Mars', april: 'Avril',
      may: 'Mai', june: 'Juin', july: 'Juillet', august: 'Août',
      september: 'Septembre', october: 'Octobre', november: 'Novembre', december: 'Décembre',
      sun: 'Dim', mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Jeu', fri: 'Ven', sat: 'Sam',
      protocolTitle: 'PROTOCOLE DE COMPTE RÉEL',
      protocolChecklistTitle: 'Checklist Avant Trading',
      reviewDataTitle: 'Révision des Données',
      chartAnalysisTitle: 'Analyse Graphique',
      technicalReviewTitle: 'Révision Technique',
      detailedReviewTitle: 'Révision Détaillée',
      protocolChecklistDetail: 'Vérifier que tous les indicateurs sont alignés',
      reviewDataDetail: 'Analyser les données historiques',
      chartAnalysisDetail: 'Identifier supports et résistances clés',
      technicalReviewDetail: 'Vérifier les modèles de chandeliers',
      detailedReviewDetail: 'Confirmer tous les signaux',
      evaluationPanelTitle: 'PANNEAU D\'ÉVALUATION',
      protocolCompliance: 'Conformité au Protocole',
      totalAdvance: 'AVANCE TOTAL',
    },
    admin: {
      title: 'Panneau Administration',
      addUser: 'Ajouter Utilisateur',
      newUser: 'Nouvel Utilisateur',
      editUser: 'Modifier Utilisateur',
      createUser: 'Créer Utilisateur',
      updateUser: 'Mettre à Jour',
      usernameLabel: 'Nom d\'utilisateur',
      emailLabel: 'Email',
      passwordLabel: 'Mot de passe',
      newPasswordLabel: 'Nouveau Mot de passe',
      assignAdmin: 'Assigner comme Administrateur',
      adminRole: 'Admin',
      userRole: 'Utilisateur',
      user: 'Utilisateur',
      userEmail: 'Utilisateur/Email',
      role: 'Rôle',
      actions: 'Actions',
      edit: 'Modifier',
      delete: 'Supprimer',
      createdSuccess: 'créé avec succès',
      updatedSuccess: 'mis à jour avec succès',
      deletedSuccess: 'Utilisateur supprimé',
      deleteConfirm: 'Êtes-vous sûr de supprimer cet utilisateur?',
      code: 'Code',
      noEmail: 'Pas d\'email',
      errorLoading: 'Erreur de chargement',
      connectionError: 'Erreur de connexion',
      errorCreating: 'Erreur de création',
      errorUpdating: 'Erreur de mise à jour',
      errorDeleting: 'Erreur de suppression',
    },
    settings: {
      title: 'Paramètres',
      updateProfile: 'Mettre à Jour le Profil',
      changePassword: 'Changer le Mot de Passe',
      deleteAccount: 'Supprimer le Compte',
      deleteAccountDesc: 'Cette action est permanente et supprimera toutes vos informations.',
      deleteAccountConfirm: 'Êtes-vous sûr de supprimer votre compte définitivement?',
    },
    common: {
      confirm: 'Confirmer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      save: 'Enregistrer',
      loading: 'Chargement...',
    }
  },
  pt: {
    nav: {
      home: 'Início',
      limit: 'Limite',
      contracts: 'Contratos',
      bitacora: 'Registro',
      estudio: 'Estudo',
      plan: 'Meu Plano',
      practice: 'Prática',
      admin: 'Admin',
      logout: 'Sair',
      settings: 'Configurações',
    },
    auth: {
      title: 'MÉTODO 11',
      login: 'Entre na sua conta',
      register: 'Criar uma nova conta',
      forgotCode: 'Recuperar código de acesso',
      resetPassword: 'Redefinir senha',
      username: 'Usuário',
      usernamePlaceholder: 'Seu nome de usuário',
      email: 'Email',
      emailPlaceholder: 'voce@email.com',
      recoveryCode: 'Código de Recuperação',
      recoveryCodePlaceholder: 'CÓDIGO',
      password: 'Senha',
      newPassword: 'Nova Senha',
      passwordPlaceholder: '••••••••',
      loginBtn: 'ENTRAR',
      registerBtn: 'REGISTRAR',
      sendCodeBtn: 'ENVIAR CÓDIGO',
      resetBtn: 'REDEFINIR',
      noAccount: 'Não tem conta? Registre-se',
      forgotPassword: 'Esqueceu sua senha?',
      forgotRecoveryCode: 'Esqueceu seu código de recuperação?',
      backToLogin: 'Voltar ao login',
      accountCreated: 'Conta Criada!',
      saveRecoveryCode: 'Guarde este código de recuperação em um lugar seguro. Você precisará dele se esquecer sua senha.',
      continueToApp: 'Continuar para o App',
      loading: 'Carregando...',
      errorLogin: 'Erro ao fazer login',
      errorRegister: 'Erro ao registrar',
      errorReset: 'Erro ao redefinir senha',
      errorRecover: 'Erro ao recuperar código',
      errorConnection: 'Erro de conexão',
      resetSuccess: 'Senha redefinida. Novo código: ',
      rememberMe: 'Lembrar de mim',
      googleLogin: 'Continuar com Google',
      or: 'ou',
    },
    home: {
      welcomeAdmin: 'Bem-vindo, Administrador',
      welcomeUser: 'Gestão centralizada das suas operações de trading',
      newEntry: 'NOVA ENTRADA',
      newEntryDesc: 'Registre uma nova operação no seu registro',
      calculators: 'Calculadoras',
      limitTitle: 'Calculadora de Limite',
      limitDesc: 'Calcule 10% e o custo total com taxa do corretor',
      contractsTitle: 'Calculadora de Contratos',
      contractsDesc: 'Calcule quantos contratos você pode comprar',
      practiceTitle: 'Prática',
      practiceDesc: 'Calendário de disciplina e protocolo de conta real',
      databases: 'Bancos de Dados',
      adminAndData: 'Admin e Dados',
      bitacoraTitle: 'Registro',
      bitacoraDesc: 'Histórico completo de todas as suas operações',
      estudioTitle: 'Estudo',
      estudioDesc: 'Análise profunda de trades negativos',
      planTitle: 'Meu Plano',
      planDesc: 'Planejamento e acompanhamento de objetivos',
      adminTitle: 'Painel Admin',
      adminDesc: 'Gestão de usuários e acessos',
    },
    calc: {
      limitTitle: 'Calculadora de Limite',
      contractsTitle: 'Calculadora de Contratos',
      currentPrice: 'Preço Atual',
      brokerFee: 'Taxa do Corretor',
      targetPercent: 'Porcentagem Alvo',
      percentOfValue: 'do Preço',
      totalValue: 'Valor Total',
      contractValue: 'Valor do Contrato',
      totalBudget: 'Orçamento Total',
      quantityContracts: 'Quantidade de Contratos',
    },
    bitacora: {
      newEntry: 'Nova Entrada',
      date: 'Data',
      time: 'Hora',
      symbol: 'Símbolo',
      strike: 'Strike',
      expDate: 'Expiração',
      type: 'Tipo',
      qty: 'Qtd',
      buyPrice: 'Preço Compra',
      totalInvested: 'Inv. Total',
      limitPrice: 'Preço Limite',
      sellDate: 'Data Venda',
      sellTime: 'Hora Venda',
      sellPrice: 'Preço Venda',
      totalSale: 'Venda Total',
      profit: 'Lucro',
      profitPercent: '% Lucro',
      td: 'TD',
      notes: 'Notas',
      noEntries: 'Nenhuma entrada ainda. Adicione seu primeiro trade!',
      call: 'Call',
      put: 'Put',
    },
    plan: {
      title: 'Meu Plano de Trading',
      initialInvestment: 'Investimento Inicial',
      description: 'Descrição',
      addGoal: 'Adicionar Objetivo',
      noGoals: 'Nenhum objetivo definido',
      resetConfirm: 'Tem certeza de redefinir o plano?',
    },
    practice: {
      disciplineCalendar: 'Calendário de Disciplina',
      resetMonth: 'Redefinir Mês',
      resetYear: 'Redefinir Ano',
      resetMonthConfirm: 'Redefinir todos os dias deste mês?',
      resetYearConfirm: 'Redefinir o ano inteiro?',
      january: 'Janeiro', february: 'Fevereiro', march: 'Março', april: 'Abril',
      may: 'Maio', june: 'Junho', july: 'Julho', august: 'Agosto',
      september: 'Setembro', october: 'Outubro', november: 'Novembro', december: 'Dezembro',
      sun: 'Dom', mon: 'Seg', tue: 'Ter', wed: 'Qua', thu: 'Qui', fri: 'Sex', sat: 'Sáb',
      protocolTitle: 'PROTOCOLO DE CONTA REAL',
      protocolChecklistTitle: 'Checklist Antes do Trading',
      reviewDataTitle: 'Revisão de Dados',
      chartAnalysisTitle: 'Análise Gráfica',
      technicalReviewTitle: 'Revisão Técnica',
      detailedReviewTitle: 'Revisão Detalhada',
      protocolChecklistDetail: 'Verificar que todos os indicadores estão alinhados',
      reviewDataDetail: 'Analisar dados históricos',
      chartAnalysisDetail: 'Identificar suportes e resistências chave',
      technicalReviewDetail: 'Verificar padrões de velas',
      detailedReviewDetail: 'Confirmar todos os sinais',
      evaluationPanelTitle: 'PAINEL DE AVALIAÇÃO',
      protocolCompliance: 'Conformidade ao Protocolo',
      totalAdvance: 'AVANCE TOTAL',
    },
    admin: {
      title: 'Painel Administrativo',
      addUser: 'Adicionar Usuário',
      newUser: 'Novo Usuário',
      editUser: 'Editar Usuário',
      createUser: 'Criar Usuário',
      updateUser: 'Atualizar',
      usernameLabel: 'Nome de usuário',
      emailLabel: 'Email',
      passwordLabel: 'Senha',
      newPasswordLabel: 'Nova Senha',
      assignAdmin: 'Atribuir como Administrador',
      adminRole: 'Admin',
      userRole: 'Usuário',
      user: 'Usuário',
      userEmail: 'Usuário/Email',
      role: 'Função',
      actions: 'Ações',
      edit: 'Editar',
      delete: 'Excluir',
      createdSuccess: 'criado com sucesso',
      updatedSuccess: 'atualizado com sucesso',
      deletedSuccess: 'Usuário excluído',
      deleteConfirm: 'Tem certeza de excluir este usuário?',
      code: 'Código',
      noEmail: 'Sem email',
      errorLoading: 'Erro ao carregar',
      connectionError: 'Erro de conexão',
      errorCreating: 'Erro ao criar',
      errorUpdating: 'Erro ao atualizar',
      errorDeleting: 'Erro ao excluir',
    },
    settings: {
      title: 'Configurações',
      updateProfile: 'Atualizar Perfil',
      changePassword: 'Mudar Senha',
      deleteAccount: 'Excluir Conta',
      deleteAccountDesc: 'Esta ação é permanente e excluirá todas as suas informações.',
      deleteAccountConfirm: 'Tem certeza de excluir sua conta permanentemente?',
    },
    common: {
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      save: 'Salvar',
      loading: 'Carregando...',
    }
  },
  it: {
    nav: {
      home: 'Home',
      limit: 'Limite',
      contracts: 'Contratti',
      bitacora: 'Registro',
      estudio: 'Studio',
      plan: 'Il Mio Piano',
      practice: 'Pratica',
      admin: 'Admin',
      logout: 'Esci',
      settings: 'Impostazioni',
    },
    auth: {
      title: 'METODO 11',
      login: 'Accedi al tuo account',
      register: 'Crea un nuovo account',
      forgotCode: 'Recupera codice di accesso',
      resetPassword: 'Reimposta password',
      username: 'Nome utente',
      usernamePlaceholder: 'Il tuo nome utente',
      email: 'Email',
      emailPlaceholder: 'tu@email.com',
      recoveryCode: 'Codice di Recupero',
      recoveryCodePlaceholder: 'CODICE',
      password: 'Password',
      newPassword: 'Nuova Password',
      passwordPlaceholder: '••••••••',
      loginBtn: 'ACCEDI',
      registerBtn: 'REGISTRATI',
      sendCodeBtn: 'INVIA CODICE',
      resetBtn: 'REIMPOSTA',
      noAccount: 'Non hai un account? Registrati',
      forgotPassword: 'Password dimenticata?',
      forgotRecoveryCode: 'Codice di recupero dimenticato?',
      backToLogin: 'Torna al login',
      accountCreated: 'Account Creato!',
      saveRecoveryCode: 'Salva questo codice di recupero in un luogo sicuro. Ne avrai bisogno se dimentichi la password.',
      continueToApp: 'Continua all\'App',
      loading: 'Caricamento...',
      errorLogin: 'Errore di accesso',
      errorRegister: 'Errore di registrazione',
      errorReset: 'Errore reimpostazione password',
      errorRecover: 'Errore recupero codice',
      errorConnection: 'Errore di connessione',
      resetSuccess: 'Password reimpostata. Nuovo codice: ',
      rememberMe: 'Ricordami',
      googleLogin: 'Continua con Google',
      or: 'o',
    },
    home: {
      welcomeAdmin: 'Benvenuto, Amministratore',
      welcomeUser: 'Gestione centralizzata delle tue operazioni di trading',
      newEntry: 'NUOVA ENTRATA',
      newEntryDesc: 'Registra una nuova operazione nel tuo registro',
      calculators: 'Calcolatrici',
      limitTitle: 'Calcolatrice Limite',
      limitDesc: 'Calcola il 10% e il costo totale con commissione broker',
      contractsTitle: 'Calcolatrice Contratti',
      contractsDesc: 'Calcola quanti contratti puoi acquistare',
      practiceTitle: 'Pratica',
      practiceDesc: 'Calendario disciplina e protocollo conto reale',
      databases: 'Database',
      adminAndData: 'Admin e Dati',
      bitacoraTitle: 'Registro',
      bitacoraDesc: 'Storico completo di tutte le tue operazioni',
      estudioTitle: 'Studio',
      estudioDesc: 'Analisi approfondita dei trade negativi',
      planTitle: 'Il Mio Piano',
      planDesc: 'Pianificazione e monitoraggio obiettivi',
      adminTitle: 'Pannello Admin',
      adminDesc: 'Gestione utenti e accessi',
    },
    calc: {
      limitTitle: 'Calcolatrice Limite',
      contractsTitle: 'Calcolatrice Contratti',
      currentPrice: 'Prezzo Attuale',
      brokerFee: 'Commissione Broker',
      targetPercent: 'Percentuale Obiettivo',
      percentOfValue: 'del Prezzo',
      totalValue: 'Valore Totale',
      contractValue: 'Valore Contratto',
      totalBudget: 'Budget Totale',
      quantityContracts: 'Quantità Contratti',
    },
    bitacora: {
      newEntry: 'Nuova Entrata',
      date: 'Data',
      time: 'Ora',
      symbol: 'Simbolo',
      strike: 'Strike',
      expDate: 'Scadenza',
      type: 'Tipo',
      qty: 'Qtà',
      buyPrice: 'Prezzo Acquisto',
      totalInvested: 'Inv. Totale',
      limitPrice: 'Prezzo Limite',
      sellDate: 'Data Vendita',
      sellTime: 'Ora Vendita',
      sellPrice: 'Prezzo Vendita',
      totalSale: 'Vendita Totale',
      profit: 'Profitto',
      profitPercent: '% Profitto',
      td: 'TD',
      notes: 'Note',
      noEntries: 'Nessuna entrata ancora. Aggiungi il tuo primo trade!',
      call: 'Call',
      put: 'Put',
    },
    plan: {
      title: 'Il Mio Piano di Trading',
      initialInvestment: 'Investimento Iniziale',
      description: 'Descrizione',
      addGoal: 'Aggiungi Obiettivo',
      noGoals: 'Nessun obiettivo definito',
      resetConfirm: 'Sei sicuro di reimpostare il piano?',
    },
    practice: {
      disciplineCalendar: 'Calendario Disciplina',
      resetMonth: 'Reimposta Mese',
      resetYear: 'Reimposta Anno',
      resetMonthConfirm: 'Reimpostare tutti i giorni di questo mese?',
      resetYearConfirm: 'Reimpostare l\'intero anno?',
      january: 'Gennaio', february: 'Febbraio', march: 'Marzo', april: 'Aprile',
      may: 'Maggio', june: 'Giugno', july: 'Luglio', august: 'Agosto',
      september: 'Settembre', october: 'Ottobre', november: 'Novembre', december: 'Dicembre',
      sun: 'Dom', mon: 'Lun', tue: 'Mar', wed: 'Mer', thu: 'Gio', fri: 'Ven', sat: 'Sab',
      protocolTitle: 'PROTOCOLLO CONTO REALE',
      protocolChecklistTitle: 'Checklist Prima del Trading',
      reviewDataTitle: 'Revisione Dati',
      chartAnalysisTitle: 'Analisi Grafico',
      technicalReviewTitle: 'Revisione Tecnica',
      detailedReviewTitle: 'Revisione Dettagliata',
      protocolChecklistDetail: 'Verificare che tutti gli indicatori siano allineati',
      reviewDataDetail: 'Analizzare dati storici',
      chartAnalysisDetail: 'Identificare supporti e resistenze chiave',
      technicalReviewDetail: 'Verificare pattern candlestick',
      detailedReviewDetail: 'Confermare tutti i segnali',
      evaluationPanelTitle: 'PANNELLO DI VALUTAZIONE',
      protocolCompliance: 'Conformità al Protocollo',
      totalAdvance: 'AVANZAMENTO TOTALE',
    },
    admin: {
      title: 'Pannello Amministrativo',
      addUser: 'Aggiungi Utente',
      newUser: 'Nuovo Utente',
      editUser: 'Modifica Utente',
      createUser: 'Crea Utente',
      updateUser: 'Aggiorna',
      usernameLabel: 'Nome utente',
      emailLabel: 'Email',
      passwordLabel: 'Password',
      newPasswordLabel: 'Nuova Password',
      assignAdmin: 'Assegna come Amministratore',
      adminRole: 'Admin',
      userRole: 'Utente',
      user: 'Utente',
      userEmail: 'Utente/Email',
      role: 'Ruolo',
      actions: 'Azioni',
      edit: 'Modifica',
      delete: 'Elimina',
      createdSuccess: 'creato con successo',
      updatedSuccess: 'aggiornato con successo',
      deletedSuccess: 'Utente eliminato',
      deleteConfirm: 'Sei sicuro di eliminare questo utente?',
      code: 'Codice',
      noEmail: 'Nessun email',
      errorLoading: 'Errore caricamento',
      connectionError: 'Errore di connessione',
      errorCreating: 'Errore creazione',
      errorUpdating: 'Errore aggiornamento',
      errorDeleting: 'Errore eliminazione',
    },
    settings: {
      title: 'Impostazioni',
      updateProfile: 'Aggiorna Profilo',
      changePassword: 'Cambia Password',
      deleteAccount: 'Elimina Account',
      deleteAccountDesc: 'Questa azione è permanente ed eliminerà tutte le tue informazioni.',
      deleteAccountConfirm: 'Sei sicuro di eliminare il tuo account permanentemente?',
    },
    common: {
      confirm: 'Conferma',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      save: 'Salva',
      loading: 'Caricamento...',
    }
  }
};
